/*import React from 'react';
import { Link } from 'react-router-dom';
import './Header.css';
import logo from "../assets/Logo/Quipo_FullName1.png";

const Header = () => {
  return (
    <header>
      
      <Link to="/"> <img src={logo} alt="Quipo Logo" className="logo" /></Link>
      <nav>
        <Link to="/">Home</Link>
        <Link to="/pitch">Pitch</Link>
        <Link to ="/roadmap">Roadmap</Link>
        <Link to="/about">About</Link>
        <Link to="/contact">Contact Us</Link>
      </nav>
    </header>
  );
};

export default Header;*/

/* Responsive Header with Hamburger Menu */

import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import './Header.css';
import logo from "../assets/Logo/Quipo_FullName1.png";

const Header = () => {
  const [menuOpen, setMenuOpen] = useState(false);

  const toggleMenu = () => {
    setMenuOpen(!menuOpen);
  };

  return (
    <header>
      <div className="header-container">
        <div className="mobile-menu-button">
          <div className="hamburger-menu" onClick={toggleMenu}>
            <div className={`hamburger-line ${menuOpen ? 'open' : ''}`}></div>
            <div className={`hamburger-line ${menuOpen ? 'open' : ''}`}></div>
            <div className={`hamburger-line ${menuOpen ? 'open' : ''}`}></div>
          </div>
        </div>
        
        <Link to="/" className="logo-link"> 
          <img src={logo} alt="Quipo Logo" className="logo" />
        </Link>
        
        <nav className={menuOpen ? 'open' : ''}>
          <Link to="/" onClick={toggleMenu}>Home</Link>
          <Link to="/pitch" onClick={toggleMenu}>Pitch</Link>
          <Link to="/roadmap" onClick={toggleMenu}>Roadmap</Link>
          <Link to="/about" onClick={toggleMenu}>About</Link>
          <Link to="/contact" onClick={toggleMenu}>Contact Us</Link>
        </nav>
      </div>
    </header>
  );
};

export default Header;